import { RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'
import { IStoreState, IVehicleInfo } from '../../types'
import {
  getSingleVehicle,
  updateOneVehicle,
  getVehicleCreateOptions,
  actionCreators
} from '../../state/actions/vehicles'
import VehicleForm from '../../components/vehicles/VehicleForm'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<{ id: string }>) {
  return {
    ...ownProps,
    organizationId: state.organizations.currentOrgId,
    id: ownProps.match.params.id,
    isRequesting: state.vehicles.isLoading,
    isRequestingError: state.vehicles.error,
    vehicleCreateOptions: state.vehicleCreateOptions,
    createEditVehicle: state.vehicles.createEditVehicle,
    vehicle: state.vehicles.items[ownProps.match.params.id],
    savedVehicleId: state.vehicles.savedVehicleId,
    isDisabledToSetOwnerProvider: true
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    createOrUpdateOne: (data: IVehicleInfo) => dispatch(updateOneVehicle(data)),
    getSingleVehicle: (id: string) => dispatch(getSingleVehicle(id)),
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions()),
    setVehicleSavedStateToInitial: () => dispatch(actionCreators.setVehicleSavedStateToInitial())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleForm)



// WEBPACK FOOTER //
// ./src/containers/vehicles/EditVehicleFormik.ts